import * as z from "zod";

export const getRithumAuthUrl = {
  name: "getRithumAuthUrl" as const,
  input: z.object({}),
  output: z.object({ url: z.string() }),
};
